import React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetTalentWithIncompleteProfileQuery } from '../../reactWrapper/Redux/apiSlice';

import Status from '../Status/Status';
import Table from './Table';
import Pagination from '../Pagination/Pagination';
import ControlledModal from '../Modal/ControlledModal';


const IncompleteProfileTable = () => {

  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedTalentName, setSelectedTalentName] = useState('');

  const { data } = useGetTalentWithIncompleteProfileQuery({
    page: page + 1,
    limit: pageSize,
  })

  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    [page]
  );

  const openTasksModal = (talent) => {
    setSelectedTasks(talent.tasks || []);
    setSelectedTalentName(`${talent.firstName} ${talent.lastName}`);
    setIsModalOpen(true);
  };

  const tableHeader = useMemo(
    () => [
      {
        title: 'Talents',
        key: 'talent',
      },
      {
        title: 'Role',
        key: 'role',
      },
      {
        title: 'Date',
        key: 'date',
      },
      {
        title: 'Missing Tasks',
        key: 'status',
      },
      {
        title: '',
        key: 'details',
      },
    ],
    []
  );



  const modifiedIncompleteProfileList = useMemo(() => {
    return data?.talents?.map((each) => [
      <div className='flex gap-[18px] items-center'>
        <div className='w-14 h-14'>
          <img
            src={each?.photo ?? ""}
            alt={each?.firstName ?? ""}
          />
        </div>
        <div>
          <p>{each?.firstName + " " + each?.lastName}</p>
          <p className='text-xs text-gray-500'>{each?.email}</p>
        </div>
      </div>,
      each.primaryStack ?? "N/A",
      new Date(each?.created_at).toLocaleDateString(),
      <div className='flex flex-wrap gap-1'>
        <span 
          onClick={() => openTasksModal(each)}
          className='text-[10px] bg-red-100 text-red-600 px-2 py-1 rounded cursor-pointer hover:bg-red-200 transition-colors inline-block'
        >
          {each.tasks?.length || 0} Tasks - View Details
        </span>
      </div>,
      <Link
        className='text-sm inline-block rounded-lg border border-border py-[1.56px] px-[11.7px] text-muted-foreground '
        to={`/incomplete-profile/${each?.id}`}
      >
        Details
      </Link>
    ])
  }, [data]);

  useEffect(() => {
    setTotalCount(data?.total ?? 0);
  }, [data]);

  return (
    <div className='w-full space-y-4'>

      <Table
        header={tableHeader}
        label='List of Talents with incomplete profile'
        column={modifiedIncompleteProfileList}
      />

      <section className="w-full">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />
      </section>

      {/* Task List Modal */}
      <ControlledModal 
        open={isModalOpen} 
        closeModal={() => setIsModalOpen(false)}
        contentStyle={{ width: '400px', borderRadius: '12px', padding: '24px' }}
      >
        <div className="bg-white rounded-sm">

          <div className="flex justify-between items-center mb-4 py-2 px-3  border-b">
            <h3 className="text-lg font-bold text-gray-800">Missing Tasks</h3>
            <button 
              onClick={() => setIsModalOpen(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="mb-4 px-3">
            <p className="text-sm text-gray-600">Pending tasks for <span className="font-semibold text-gray-900">{selectedTalentName}</span>:</p>
          </div>

          <ul className="space-y-3 p-3">
            {selectedTasks.length > 0 ? (
              selectedTasks.map((task, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm text-gray-700">
                  <span className="flex-shrink-0 w-5 h-5 bg-red-50 text-red-500 rounded-full flex items-center justify-center text-[10px] font-bold mt-0.5">
                    {idx + 1}
                  </span>
                  <span>{task.label}</span>
                </li>
              ))
            ) : (
              <li className="text-sm text-green-600 font-medium italic">All tasks completed!</li>
            )}
          </ul>

          <div className="mt-8  justify-end hidden">
            <button
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </ControlledModal>
    </div>
  );
};


export default IncompleteProfileTable
